import { render, staticRenderFns } from "./FestivalPrize.vue?vue&type=template&id=bee1ab3e&"
import script from "./FestivalPrize.vue?vue&type=script&lang=js&"
export * from "./FestivalPrize.vue?vue&type=script&lang=js&"
import style0 from "./FestivalPrize.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VImg,VSimpleTable})
